// Shared constants/helpers for the console's Microsoft Entra ID sign-in
// (R-306). Centralized here so the authorize-URL builder (SignInPage) and the
// token-exchange call (MicrosoftCallbackPage) can never derive a different
// redirect_uri string from each other — Microsoft's token endpoint requires
// an exact match to the value sent to /authorize.
//
// Env vars (no .env.example in this repo; set these in the console's Cloudflare
// Pages project / local .env):
//   VITE_MICROSOFT_CLIENT_ID     — Entra multitenant app registration client ID
//   VITE_MICROSOFT_REDIRECT_URI  — optional override; defaults to
//                                  `${location.origin}/auth/microsoft/callback`

export const MICROSOFT_PKCE_VERIFIER_KEY = 'anchor_ms_pkce_verifier';
export const MICROSOFT_PKCE_STATE_KEY = 'anchor_ms_pkce_state';

export function getMicrosoftClientId(): string | undefined {
  return import.meta.env.VITE_MICROSOFT_CLIENT_ID as string | undefined;
}

/** The single source of truth for the redirect_uri string — used both when
 * building the /authorize URL and when exchanging the code, so they can't drift. */
export function getMicrosoftRedirectUri(): string {
  return (
    (import.meta.env.VITE_MICROSOFT_REDIRECT_URI as string | undefined) ??
    `${window.location.origin}/auth/microsoft/callback`
  );
}

export function buildMicrosoftAuthorizeUrl(params: {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  state: string;
}): string {
  const url = new URL('https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize');
  url.searchParams.set('client_id', params.clientId);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('redirect_uri', params.redirectUri);
  url.searchParams.set('scope', 'openid profile email');
  url.searchParams.set('code_challenge', params.codeChallenge);
  url.searchParams.set('code_challenge_method', 'S256');
  url.searchParams.set('state', params.state);
  return url.toString();
}
